if (!customElements.get('country-selector')) {
  customElements.define(
    'country-selector',
    class CountrySelector extends HTMLElement {
      connectedCallback() {
        this.countrySelect = this.querySelector('[name="address[country]"]');
        this.provinceSelect = this.querySelector('[name="address[province]"]');

        if (this.countrySelect) {
          this.countrySelect.addEventListener('change', this.updateProvinces.bind(this));
          this.setDefaultCountry();
        }
      }

      setDefaultCountry() {
        const defaultCountry = this.getAttribute('country');
        if (!defaultCountry) return;

        const options = this.countrySelect.options;
        for (let i = 0; i < options.length; i++) {
          if (options[i].textContent.trim() === defaultCountry || options[i].value === defaultCountry) {
            this.countrySelect.selectedIndex = i;
            break;
          }
        }
        this.updateProvinces();
      }

      updateProvinces() {
        if (!this.provinceSelect) return;
        // Guard: bail if no country is selected (selectedIndex === -1).
        // Hits when the dropdown has no default value, or before the user
        // picks one — without this, options[-1] is undefined and the next
        // line throws on getAttribute.
        if (!this.countrySelect || this.countrySelect.selectedIndex < 0) return;

        const selected = this.countrySelect.options[this.countrySelect.selectedIndex];
        if (!selected) return;
        const raw = selected.getAttribute('data-provinces');
        let provinces = [];

        try {
          provinces = JSON.parse(raw) || [];
        } catch (e) {
          provinces = [];
        }

        this.provinceSelect.innerHTML = '';

        // Guard: closest('.form-control') returns null if the markup
        // changes; without this, '.hidden = …' throws on null.
        const provinceWrapper = this.provinceSelect.closest('.form-control');

        if (provinces.length === 0) {
          if (provinceWrapper) provinceWrapper.hidden = true;
        } else {
          if (provinceWrapper) provinceWrapper.hidden = false;
          provinces.forEach(function (province) {
            const option = document.createElement('option');
            option.value = province[0];
            option.textContent = province[1];
            this.provinceSelect.appendChild(option);
          }.bind(this));
        }
      }
    }
  );
}

if (!customElements.get('shipping-estimator')) {
  customElements.define(
    'shipping-estimator',
    class ShippingEstimator extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.resultsRegion = this.querySelector('[aria-live="polite"]');
        this.button.addEventListener('click', this.onSubmit.bind(this));
      }

      onSubmit() {
        const country = this.querySelector('[name="address[country]"]');
        const province = this.querySelector('[name="address[province]"]');
        const zip = this.querySelector('[name="address[zip]"]');

        this.clearErrors();

        var errors = [];
        if (zip && zip.value.trim() === '') {
          errors.push('Please enter a zip / postal code.');
        } else if (zip && zip.value.trim().length < 3) {
          errors.push('Please enter a valid zip / postal code.');
        }
        if (country && !country.value) {
          errors.push('Please select a country.');
        }

        if (errors.length > 0) {
          this.showValidationErrors(errors);
          return;
        }

        const params = new URLSearchParams();
        if (country) params.set('shipping_address[country]', country.value);
        if (province) {
          const provinceWrapper = province.closest('.form-control');
          if (!provinceWrapper || !provinceWrapper.hidden) {
            params.set('shipping_address[province]', province.value);
          }
        }
        if (zip) params.set('shipping_address[zip]', zip.value.trim());

        this.button.setAttribute('disabled', '');
        this.button.setAttribute('aria-busy', 'true');
        this.resultsRegion.hidden = true;
        this.resultsRegion.innerHTML = '';

        fetch('/cart/shipping_rates.json?' + params.toString())
          .then(function (response) {
            return response.json().then(function (data) {
              return { ok: response.ok, data: data };
            });
          })
          .then(
            function (result) {
              if (result.ok) {
                this.renderRates(result.data.shipping_rates);
              } else {
                this.renderErrors(result.data);
              }
            }.bind(this)
          )
          .catch(
            function () {
              this.renderErrors({ errors: 'Unable to estimate shipping at this time. Please try again.' });
            }.bind(this)
          )
          .finally(
            function () {
              this.button.removeAttribute('disabled');
              this.button.removeAttribute('aria-busy');
              this.resultsRegion.hidden = false;
            }.bind(this)
          );
      }

      clearErrors() {
        this.resultsRegion.innerHTML = '';
        this.resultsRegion.hidden = true;
        this.querySelectorAll('.shipping-estimator__field-error').forEach(function (el) {
          el.remove();
        });
        this.querySelectorAll('.input--error').forEach(function (el) {
          el.classList.remove('input--error');
        });
      }

      showValidationErrors(errors) {
        var zip = this.querySelector('[name="address[zip]"]');
        if (zip) zip.classList.add('input--error');

        var html = '';
        errors.forEach(function (msg) {
          html += '<p class="shipping-estimator__error">' + msg + '</p>';
        });
        this.resultsRegion.innerHTML = html;
        this.resultsRegion.hidden = false;
      }

      renderRates(rates) {
        if (!rates || rates.length === 0) {
          this.resultsRegion.innerHTML =
            '<p class="shipping-estimator__message">Sorry, we do not ship to this destination.</p>';
          return;
        }

        let html = '<ul class="shipping-estimator__rates list-unstyled" role="list">';
        rates.forEach(function (rate) {
          const price = parseFloat(rate.price);
          const priceText = price === 0 ? 'Free' : rate.currency + ' ' + rate.price;
          html +=
            '<li class="shipping-estimator__rate">' +
            '<span class="shipping-estimator__rate-name">' +
            rate.name +
            '</span>' +
            '<span class="shipping-estimator__rate-price">' +
            priceText +
            '</span>' +
            '</li>';
        });
        html += '</ul>';
        this.resultsRegion.innerHTML = html;
      }

      renderErrors(data) {
        var messages = '';
        if (typeof data === 'string') {
          messages = '<p class="shipping-estimator__error">' + data + '</p>';
        } else {
          var errorObj = data.errors || data;
          if (typeof errorObj === 'string') {
            messages = '<p class="shipping-estimator__error">' + errorObj + '</p>';
          } else {
            for (var field in errorObj) {
              if (Object.prototype.hasOwnProperty.call(errorObj, field)) {
                var fieldErrors = Array.isArray(errorObj[field]) ? errorObj[field] : [errorObj[field]];
                fieldErrors.forEach(function (msg) {
                  messages += '<p class="shipping-estimator__error">' + msg + '</p>';
                });
              }
            }
          }
        }
        this.resultsRegion.innerHTML = messages || '<p class="shipping-estimator__error">Unable to estimate shipping for this address.</p>';
      }
    }
  );
}